import React, { useState } from "react";
import './ThreeStateSwitch.scss'

const Switch = ({value=0, onChange, label='Content:  ' }) => {
  const [active, setActive] = useState(value);

  const handleClick = (value) => {
    setActive(value);
    if(onChange) onChange(value);
  };

  return (
    <div className="ThreeStateSwitch">
			<label>{label}</label>
      <div
        className={`switch-option ${active === 0 ? "active" : ""}`}
        onClick={() => handleClick(0)}
      >
        Safe
      </div>
      <div
        className={`switch-option ${active === 1 ? "active" : ""}`}
        onClick={() => handleClick(1)}
      >
        Everything
      </div>
      <div
        className={`switch-option ${active === 2 ? "active" : ""}`}
        onClick={() => handleClick(2)}
      >
        Adult
      </div>
    </div>
  );
};

export default Switch;
